import React, { useEffect, useCallback, useState} from 'react';
import RecordInfo from "components/upload/RecordInfo.js";
import {connect} from 'react-redux';
import Discogs from "discogs/Discogs.js";
const discogs = new Discogs();

const SourceFinder = ({sample, setIsSourcing, guildId}) => { 
    let [records, setRecords] = useState([]);
    useEffect(() => {
        discogs.searchRecords(sample.name.replace(".wav", "").replace(".flac", ""))
            .then((r) => {
                setRecords(r);
            });
    }, [sample, setRecords, setIsSourcing]);

    const save = useCallback(() => {
        sample.saveSample(guildId);
        setIsSourcing(false);
    }, [sample, setIsSourcing, guildId]);

    return (
        <div className="source-finder">
          {records.length > 0 ? 
           <RecordInfo showTags={false} sample={sample} discogs={discogs} records={records}/> :
           "No records found"}
          <div className="btns">
            {records.length > 0 ? 
            <div onClick={save} className="save-btn">
              Save Changes
            </div> : ''}
            <div className="cancel-btn" onClick={() => setIsSourcing(false)}>
              Cancel
            </div>
          </div>
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SourceFinder);
